import { reportVaddA3RequestReport } from '../../utils/log/log';
import { getFromPath, getCurrentRoute } from '../../utils/log/track/util';

// 路由跳转上报
export function handleRouterReport(eventName, stayTime = 0) {
    const from_path = getFromPath()
    const curRoute = getCurrentRoute()
    reportVaddA3RequestReport({
        event_name: eventName,
        event_data: {
            event_time: Date.now(),
            page_name: curRoute.page_name,
            page_path: curRoute.page_path,
            from_path,
            stay_time: stayTime,
        },
    });
 }
